
import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import ReactToPrint from 'react-to-print';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';


import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';




import ReactHTMLTableToExcel from 'react-html-table-to-excel';
const headCells = [

   { id: 'or_orderno', numeric: false, label: 'Invoice No' },  
  { id: 'or_name ', numeric: false, label: 'Name' },  
  { id: 'or_email', numeric: false, label: 'Email id' },  
  { id: 'or_phone', numeric: false, label: 'Phone No' },  
  
  { id: 'sb_title', numeric: false, label: 'Duration' },  
  { id: 'fromdate', numeric: false, label: 'From Date' },  
   { id: 'todate', numeric: false, label: 'To Date' },  
  
    

 ]

function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }, 


});




export default class FreezingReport extends Component {
	
    constructor(props) {
    super(props);
   
	
	 var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
     this.state = {
		 fromdate:dayjs(Date.now()),fromdate1:'',	 todate:dayjs(Date.now()),todate1:'',
		 subscribeData:[],
		 prevpage:0,totaldata:0,rowsPaging:[],search:'',order:'desc' ,orderBy:'fg_id',
		 or_name:'',or_orderno:'',
		 sb_title:'',lc_title:'',
		 FreezinData:[],subid:'',or_classtype:'',
		 
		 ExportData:[],page:0,rowsPerPage:10,
order:'desc' ,orderBy:'',redirect:false,type:'',
	          
   }
	  
	}
	  



	


handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };     
  
  	 myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 

  this.setState({[nam]: val});
  
}
  handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  

componentWillMount  () {
	

	
	document.title = "AthaYog Living - Group Freezing Report";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }


	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
this.onloadsubscribeBind();
  
}


apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxfreezinggroup.php?action=report&or_classtype='+this.state.lc_title+'&or_sb_id='+this.state.subid+'&or_name='+this.state.or_name+'&or_orderno='+this.state.or_orderno+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  FreezinData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({FreezinData:[],totaldata:0});
	 }
 
    });
}

  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};	  
	 

apiExportcall(){

 axios.get(Serverurl+'ajaxfreezinggroup.php?action=report')

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  ExportData:resp.data,  
			   
			   

		    });

     }
	 else{
		   this.setState({ExportData:[]});
	 }
 
    });
}





onloadsubscribeBind(){
  axios.post(Serverurl+'ajaxsubscription.php?action=getall&sb_type=1,2,3,4,6&sorting=sb_type')
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						subscribeData:resp.data	
							},()=>{
								
								
								 let subscribeFromApi = this.state.subscribeData.map(row => {
                          
          return {value:row.sb_id,display:row.sb_title,label:row.type,type:row.sb_type}
						 
        });
      
	
        this.setState({
          subscribeData: [{value: '', display:'Select Duration',label:'',type:'0'}].concat(subscribeFromApi)
        },()=>{});
								
							})
	
														
			}else{
				this.setState({subscribeData:[]});
			}
 
    });

}


 
  
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
  



handleClickSearch=()=>{   
   
  this.apicall(this.state.page,this.state.rowsPerPage); 
	
} 



onChangeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
	
		 this.setState({lc_title: event.target.value},()=>{ 
		
		
		 });
	}
	
	
	
	
		handlefromdateChange = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({fromdate:dayjs(date),
fromdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
	
	
		handletodateChange = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({todate:dayjs(date),
todate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
	
	
	
	
	
	
	
	
	
	
	

render() {
	
	 let prev="";
	if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return(
 
 
 <React.Fragment>
 
  <div className="mainheading"><h1>Group Freezing Report</h1></div>

<div className="clear"></div>

	
	

 <div className="searchmaster">
 <ul>
 
 
  <li><p>Name/Email/Phone</p><p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.or_name}
        inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
			
            name="or_name" onChange={this.myChangeHandler}
		
          /></p></li>
 
 <li><p>Invoice No.</p><p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.or_orderno}
        inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
			
            name="or_orderno" onChange={this.myChangeHandler}
		
          /></p></li>
		  
		  
		  
		  
		  
		  		 <li>
 <p>From Date</p>

 <LocalizationProvider dateAdapter={AdapterDayjs} >
      <DemoContainer components={['DatePicker']}>
<DatePicker fullWidth 
value= {dayjs(this.state.fromdate) }
 className="txtbox"name="fromdate"
    onChange={this.handlefromdateChange} format="YYYY/MM/DD"

/>  </DemoContainer>
    </LocalizationProvider>

 </li>
				


				 <li>
 <p>To Date</p>

 <LocalizationProvider dateAdapter={AdapterDayjs} >
      <DemoContainer components={['DatePicker']}>
<DatePicker fullWidth 
value= {dayjs(this.state.todate) }
 className="txtbox"name="todate"
    onChange={this.handletodateChange} format="YYYY/MM/DD"

/>  </DemoContainer>
    </LocalizationProvider>

 </li>
			
 
			
				
 <li><p>Duration</p>
 
 <p><FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native 	inputProps={{tabIndex: "3"}}
			value={this.state.subid}
			onChange={this.myChangeHandler}
			name='subid'
			
			fullwidth
			
			
			>
		
		
			{this.state.subscribeData.map((row,index) =>{
	
	
		this.state.subscribeData.filter(options => options.type == row.type);
	
	if(prev!=row.type)
	{
	prev=row.type
				return(
				 <React.Fragment>
				  <optgroup label={row.label}>
				 {this.state.subscribeData.filter(options => options.type == row.type).map((sub) =>{ return(
			
				
				<option  
            
				  value={sub.value}
				>
				  {sub.display}
				</option  >
				
				)})}
		</optgroup>
	 </React.Fragment>			 
	)
	}
	
	})}
			 </Select>
		</FormControl></p></li>
		
		
		
		
	
			





		
				
					<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button> &nbsp;
		<ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="FreezingGroupReport"
							filename="Freezing Group Report"
							sheet="Freezing Group Report"
							buttonText="EXPORT"/>
							
			
			
				</p>		
		</li>
		
		
		</ul>
		
</div>	

	

	<div ref={el => (this.componentRef = el)}  >
	
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.FreezinData.length}
            />
                      <TableBody>
                     {stableSort(this.state.FreezinData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >
<TableCell style={{"width":"20px"}}>{item.or_orderno}</TableCell>
<TableCell style={{"width":"20px"}}>{item.or_name}</TableCell>

<TableCell style={{"width":"20px"}}>{item.or_email}</TableCell>
<TableCell style={{"width":"20px"}}>{item.or_phone}</TableCell>

<TableCell style={{"width":"20px"}}>{item.sb_title}</TableCell>
<TableCell style={{"width":"20px"}}>{item.fromdate}</TableCell>
<TableCell style={{"width":"20px"}}>{item.todate}</TableCell>

	


	

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
         rowsPerPageOptions={[50,100,200,300,400]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      /> 
  </Paper>
    
</div>



<div style={{"display":"none"}}>
			
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="FreezingGroupReport">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.ExportData.length}
            />
                      <TableBody>
                     {stableSort(this.state.ExportData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >


<TableCell style={{"width":"20px"}}>{item.or_name}</TableCell>

<TableCell style={{"width":"20px"}}>{item.or_email}</TableCell>
<TableCell style={{"width":"20px"}}>{item.or_phone}</TableCell>
<TableCell style={{"width":"20px"}}>{item.or_orderno}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sb_title}</TableCell>
<TableCell style={{"width":"20px"}}>{item.classtype}</TableCell>


	


	
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
 
  </Paper>
 
</div>




 </React.Fragment>
 



);


		}
	
}

